import React from "react"
import "./PasswordStrength.css"

const hasNumber = value => {
  return new RegExp(/[0-9]/).test(value)
}
const hasMixed = value => {
  return new RegExp(/[a-z]/).test(value) && new RegExp(/[A-Z]/).test(value)
}
const hasSpecial = value => {
  return new RegExp(/[!#@$%^&*)(+=._-]/).test(value)
}
const strengthIndicator = value => {
  let strength = 0
  if (value.length >= 8) {
    strength++
    if (hasNumber(value)) strength++
    if (hasSpecial(value)) strength++
    if (hasMixed(value)) strength++
  }

  return strength
}
function PasswordStrength({ password }) {
  if (password.length > 0) {
    let label = "weak"
    if (strengthIndicator(password) === 2) {
      label = "fair"
    }
    if (strengthIndicator(password) === 3) {
      label = "good"
    }
    if (strengthIndicator(password) >= 4) {
      label = "strong"
    }
    return (
      <div className={`PasswordStrength ${label}`}>
        <span className="PasswordStrength-title">Password Strength</span>
        <span className="PasswordStrength-label">{label}</span>
        <span className="PasswordStrength-bar" />
      </div>
    )
  }
  return null
}

export default PasswordStrength
